import { render } from "./PayOutStopScamReceiptCheckDescription.vue?vue&type=template&id=1454a728&ts=true"
import script from "./PayOutStopScamReceiptCheckDescription.vue?vue&type=script&lang=ts"
export * from "./PayOutStopScamReceiptCheckDescription.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__